<template>
  <div class="bg-login">
    <div
      class="d-flex justify-center align-center wrapper-content"
      fluid
      style="height: 100vh"
    >
      <v-container class="rounded-lg px-6 py-6">
        <v-row align="center" justify="center">
          <v-col class="col-md-3">
            <v-img
              src="../assets/logo_suim.png"
              content-class="img-fluid"
              width="320px"
            ></v-img>
          </v-col>
        </v-row>

        <v-row align="center" justify="center">
          <v-col class="col-md-3">
            <v-container>

                <v-col  class="text-center">
                <h1 class="text-white " style="font-size: 26px;"> Sin acceso al recurso: Ventana duplicada </h1>
                <br>
                    <v-btn
                    fab
                    color="primary"
                    @click="back()"
                  >
                    <v-icon dark large>mdi-chevron-left</v-icon>
                  </v-btn>
                </v-col>

               
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script type="JS">
import router from "../router"
import { mapActions } from "vuex";
export default {
  name: "nofun",
  computed: {},
  data: () => ({
   
  }),
  methods: {
      ...mapActions(["logout"]),
    back() {
      //this.$router.push('login');
      this.logout();
      router.replace({ name: 'login' })
    },

  },
};
</script>
<style scoped>
.bg-login {
  background-image: url("../assets/suim_background.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #464646;
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
</style>
